import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    color: "#4c9c50",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M17.991 7.006H6.156v1.385H17.99V7.006ZM6.582 9.776h10.983c2.48 0 4.508 2.336 4.508 5.218v.419h-20v-.419c0-2.882 2.013-5.217 4.51-5.217Z" fill="currentColor"/> <path d="M21.095 15.412H3.052v1.385h18.041v-1.385Z" fill="currentColor"/>' }
  })
);